import type { ProjectState, Scenario } from "./types";

/**
 * Which events should enter the inbox right now: due FutureEvents, plus any
 * event whose eligibleWhen predicate now holds (day thresholds AND metric
 * thresholds together — not expressible with a fixed next-scene pointer).
 */
export function resolveEligibleEvents(state: ProjectState, scenario: Scenario): string[] {
  const known = new Set([...state.activeEventIds, ...state.resolvedEventIds]);

  const dueFromPending = state.pendingEvents
    .filter((pe) => pe.eligibleOnDay <= state.day)
    .map((pe) => pe.eventId)
    .filter((id) => !known.has(id));

  const dueFromConditions = scenario.events
    .filter((e) => !known.has(e.id) && !dueFromPending.includes(e.id) && e.eligibleWhen(state))
    .map((e) => e.id);

  return Array.from(new Set([...dueFromPending, ...dueFromConditions]));
}
